export const RevertIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18 18"
      width="1em"
      height="1em"
      fill="currentColor"
      {...props}
    >
      <path d="M12 15H1.5C1.085 15 0.75 14.665 0.75 14.25C0.75 13.835 1.085 13.5 1.5 13.5H12C14.0675 13.5 15.75 11.8175 15.75 9.74999C15.75 7.68249 14.0675 5.99999 12 5.99999H3.31L5.78 8.46999C5.9275 8.61749 6 8.80749 6 8.99999C6 9.19249 5.9275 9.38498 5.78 9.52999C5.4875 9.82248 5.0125 9.82248 4.72 9.52999L0.97 5.77999C0.8375 5.64749 0.765 5.47749 0.755 5.30248C0.7525 5.25248 0.755 5.20249 0.76 5.15249C0.7775 5.00999 0.8375 4.87249 0.9375 4.75749C0.95 4.74249 0.965 4.72749 0.9775 4.71499L4.72 0.969985C5.0125 0.677485 5.4875 0.677485 5.78 0.969985C6.0725 1.26249 6.0725 1.73749 5.78 2.02999L3.31 4.49999H12C14.895 4.49999 17.25 6.85499 17.25 9.74999C17.25 12.645 14.895 15 12 15Z" />
    </svg>
  );
};
